module.exports = __webpack_public_path__ + "50932c3478585695bb199ef8cf781c22.svg";